import React, { useEffect, useState, useRef } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";
import noImgThing from "../../assetsCon/assets/images/noImgThing.jpg";
import noVidThing from "../../assetsCon/assets/images/noVidThing.jpg";

// Function to convert YouTube video links to embedded format
function convertToEmbeddedLink(videoLink) {
  if (videoLink.startsWith("https://www.youtube.com")) {
    const videoId = new URL(videoLink).searchParams.get("v");
    return `https://www.youtube.com/embed/${videoId}`;
  }
  return videoLink;
}
function capitalizeName(name) {
  return name?.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });
}

const ViewCourses = () => {
  const { token, user_type } = config;
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [isDrfDelBtnEnabled, setIsDrfDelBtnEnabled] = useState(false);
  const [selectAllImageChecked, setSelectAllImageChecked] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);

  //  ------For TableViewer ------
  const coursesRef = useRef([]);
  coursesRef.current = courses;
  const [rowData, setRowData] = useState([]);
  const [activeCourses, setActiveCourses] = useState([]);
  const [inactiveCourses, setInactiveCourses] = useState([]);
  //  ------For TableViewer ------

  const viewMcq = (idNumber, courseNm) => {
    navigate(
      `/viewmcqs/course/${btoa(encodeURIComponent(idNumber))}/${btoa(
        encodeURIComponent(courseNm)
      )}?from=mcq`
    );
  };

  // const handleSelectAllVideoChange = (event) => {
  //   // setSelectAllImageChecked(false);
  //   // setSelectAllMediaChecked(false);
  //   const isChecked = event.target.checked;
  //   setSelectAllVideoChecked(isChecked);

  //   if (isChecked) {
  //     const allVideoIds = videos.map((media) => media.media_id);
  //     setSelectedMedia(allVideoIds);
  //     setIsBtnEnabled(true);
  //   } else {
  //     setSelectedMedia([]);
  //     setIsBtnEnabled(false);
  //   }
  // };

  //----------------------------------------------- select / view courses table  -------------------------------------------------R
  // Fetch all courses
  const fetchCourses = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}course`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            const coursesData = data.data.map((course) => ({
              course: course.course_name,
              status: course.status,
              userrole: course.userrole,
              course_owner: course.course_owner,
              thumbnail: course.video_thumbnail,
              image: course.image_link,
              course_duration: course.course_duration,
              duration: course.course_duration + " " + course.duration_unit,
              price: course.price,
              video: course.video_link,
              idNumber: course.course_id,
              onlyMcq: course.only_mcq
            }));
            setRowData(coursesData);
            setActiveCourses(
              coursesData.filter((course) => course.status === 1)
            );
            setInactiveCourses(
              coursesData.filter((course) => course.status !== 1)
            );
            //  ------For TableViewer ------

            setCourses(data.data);
            // console.log(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCourses();
  }, [token]);

  //----------------------------------------------- select / view single course  -------------------------------------------------R
  const btnShowHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewcourse/${encodedId}`);
  };

  // ------------------------------------------------- Edit / Update course ---------------------------------------------------- U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addcourse/${encodedId}`);
  };

  // ------------------------------------------------- view Result  ---------------------------------------------------- R
  const viewResult = (id, cname) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    const encodedCname = window.btoa(encodeURIComponent(cname));
    navigate(`/viewtestresult/course/${encodedId}/${encodedCname}`);
  };

  // ---------------------------------------------------- Delete course ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Course. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteCourse(deleteId, i);
      }
    });
  };

  //If confirm then delete course
  const handleDeleteCourse = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}course/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Course deleted successfully");

            //  ------For TableViewer ------
            const updatedCourses = [...coursesRef.current];
            updatedCourses.splice(i, 1);
            setCourses(updatedCourses);
            const coursesData = updatedCourses.map((course) => ({
              course: course.course_name,
              status: course.status,
              userrole: course.userrole,
              course_owner: course.course_owner,
              thumbnail: course.video_thumbnail,
              image: course.image_link,
              course_duration: course.course_duration,
              duration: course.course_duration + " " + course.duration_unit,
              price: course.price,
              video: course.video_link,
              idNumber: course.course_id,
              onlyMcq: course.only_mcq
            }));
            fetchCourses();
            setRowData(coursesData);
            setActiveCourses(
              coursesData.filter((course) => course.status === 1)
            );
            setInactiveCourses(
              coursesData.filter((course) => course.status !== 1)
            );
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            // course IDs Not Found
            console.error("Course IDs not found");
            triggerNotification("error", "Course IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting course:", error);
      triggerNotification("error", "Error deleting course");
    }
  };

  // ---------------------------------------------------- Duplicate course ---------------------------------------------------------
  // Show a confirmation dialog
  const btnDuplicateHandler = (duplicateId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to duplicate the course. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, duplicate it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDuplicateCourse(duplicateId, i);
      }
    });
  };

  // If confirmed, duplicate course
  const handleDuplicateCourse = async (duplicateId, i) => {
    try {
      const response = await fetch(
        `${config.host_url}course/duplicate/${duplicateId}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        triggerNotification("success", "Course duplicated successfully");
        fetchCourses();

        //  ------For TableViewer ------
      } else if (data.status === 404) {
        // Course IDs Not Found
        console.error("Course IDs not found");
        triggerNotification("error", "Course IDs not found");
      } else if (data.status === 401) {
        // Invalid Token
        console.error("Invalid token");
        triggerNotification("error", "Unauthenticated User");
      } else {
        // Internal Server Error or other HTTP errors
        console.error("Internal server error");
        triggerNotification(
          "error",
          "Internal server error, please try again later!"
        );
      }
    } catch (error) {
      console.error("Error duplicating course:", error);
      triggerNotification("error", "Error duplicating course");
    }
  };

  const coursesWithStatus1 = courses.filter((course) => course.status === 1);

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "",
      // field: "idNumber",
      width: 50,
      checkboxSelection: true,
      // cellEditor: "agCheckboxCellEditor",
    },
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    // course
    {
      headerName: "Courses",
      field: "course",
      width: 380,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image ? params.data.image : noImgThing}
            alt="Course_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.course}</p>
        </div>
      ),
    },
    // duration
    {
      field: "duration",
      filter: true,
      width: 110,
      cellRenderer: (params) => (
        <p>
          {params.data.course_duration !== null ? (
            params.data.duration
          ) : (
            <p className="flex justify-center mr-4">-</p>
          )}
        </p>
      ),
    },
    // user role
    {
      headerName: "Course By",
      field: "userrole",
      width: 200,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <p className="p-0 m-0 ">{capitalizeName(params.data.userrole)}</p>{" "}
          {params.data.userrole === "teacher" ? (
            <a
              className="p-0 m-0"
              href={`/viewteacher/${btoa(
                encodeURIComponent(params?.data?.course_owner?.id)
              )}`}
            >
              {" - " + capitalizeName(params?.data?.course_owner?.name)}
            </a>
          ) : (
            <p className="p-0 m-0">
              {" - " + capitalizeName(params?.data?.course_owner?.name)}
            </p>
          )}
        </div>
      ),
    },
    // only mcq or not
    {
      field: "only mcq's",
      filter: true,
      width: 140,
      cellRenderer: (params) => (
        <p className="px-3">
          {params.data.onlyMcq == 0 ? "No" : "Yes"}
        </p>
      ),
    },
    // price
    {
      field: "price",
      filter: true,
      width: 110,
      cellRenderer: (params) => (
        <p>
          {params.data.price !== null ? (
            params.data.price
          ) : (
            <p className="flex justify-center mr-4">-</p>
          )}
        </p>
      ),
    },
    // video
    {
      headerName: "Video",
      field: "video",
      width: 80,
      cellRenderer: (params) => (
        <div className="mt-1">
          <div className=" flex  ">
            <td className="align-top  ">
              <div
                onClick={() => {
                  setSelectedVideoIndex(params.data.video);
                  setShowVideoModal(true);
                }}
                className="relative "
              >
                <img
                  src={
                    params.data.thumbnail ? params.data.thumbnail : noVidThing
                  }
                  alt="Video Thumbnail"
                  className="cursor-pointer rounded object-cover  h-11 w-11"
                />
                <span
                  className="mdi mdi-play mdi-18px mdi-dark  bg-white rounded absolute top-[50%] left-[50%] opacity-90	"
                  style={{ transform: "translate(-50%, -50%)" }}
                ></span>
              </div>
            </td>
          </div>
        </div>
      ),
    },
  ];

  const colDefsWithoutCheckbox = colDefs.filter(
    (colDef) => colDef.headerName !== ""
  );

  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Course" subpath={["View Courses"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Courses</h5>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addcourse");
              }}
            >
              Add Course
            </button>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={activeCourses}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                onMcqView={viewMcq}
                onDoubt
                onResult={viewResult}
                resultOf="course"
                onDuplicate={btnDuplicateHandler}
                 //for delete courses
                 fetchDataAfterAction={fetchCourses}
                tableTitle="View Courses"
                btnTxtFor="courses"
                btnTxtAction={["delete"]}
                actionUrl="course/move/4"
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>

        {/* draft */}
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            
            {isDrfDelBtnEnabled && (
              <button
                type="button"
                className="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-5 mb-2 dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                // onClick={showDeleteConfirmation}
              >
                Delete
              </button>
            )}
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                fromDraft={true}
                  //for delete courses
                  fetchDataAfterAction={fetchCourses}
                tableTitle="View Courses - Draft"
                btnTxtFor="courses"
                btnTxtAction={["delete","publish"]}
                actionUrl="course/move/4"
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>

      {/* modal */}
      {showVideoModal && selectedVideoIndex !== null && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-600 bg-opacity-30 z-50">
          <div className="w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/3">
            <div className="flex justify-end">
              <button
                className="text-white"
                onClick={() => {
                  setShowVideoModal(false);
                  setSelectedVideoIndex(null);
                }}
              >
                <span className="mdi mdi-close-box-outline"></span>
              </button>
            </div>
            <video
              src={convertToEmbeddedLink(selectedVideoIndex)}
              type="video/mp4"
              playsInline
              controls
              autoPlay
              className="w-full h-full"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ViewCourses;
